import { render, staticRenderFns } from "./DokumanList.vue?vue&type=template&id=34a2179e&scoped=true"
import script from "./DokumanList.vue?vue&type=script&lang=ts"
export * from "./DokumanList.vue?vue&type=script&lang=ts"
import style0 from "./DokumanList.vue?vue&type=style&index=0&id=34a2179e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a2179e",
  null
  
)

export default component.exports